// extracted by mini-css-extract-plugin
export default {"page":"PageStyles_page__h0Otj"};